(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller("EventServicesController", EventServicesController);

  EventServicesController.$inject = ["$timeout"];

  function EventServicesController($timeout) {
  }
})();


